/* eslint-disable @typescript-eslint/no-require-imports */
import React from 'react';
import { Image, Platform, Text, View } from 'react-native';
import globalStyle from '../../../styles/globalStyle';
interface INotification {
    description: string;
}
export const NotificationDescription = ({ description }: INotification) => {
    return (

        <View style={[globalStyle.dHorizontal, { width: '100%', }]}>
            <Image
                style={globalStyle.imageIcon}
                source={require('../../../../ressources/images/NotificationRed.png')}
            />
            {Platform.OS === 'web' ? <Text style={{ maxWidth: 700, }}>
                {description}
            </Text> : <Text style={{ width: '100%', }}>
                    {description}
                </Text>
            }

        </View>
    )
}
